import React from "react";
import Text from "../../Text";
import styled, { css } from "styled-components";
import * as colors from "../../../assets/_base/colors";
import Icon from "../../Icon";
import Spinner from "../../Spinner";

const Button = styled.button`
  outline: none;
  margin: none;
  border: none;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 30px !important;
  padding-left: 6px;
  padding-right: 6px;
  background-color: white;
  margin-left: 3px;
  margin-right: 3px;
  border: 2px solid ${colors.darkBlue};
  border-bottom: 6px solid ${colors.darkBlue};
  transition: all 0.25s;
  justify-content: space-between;
  margin-bottom: 5px;
  margin-bottom: 10px;

  ${(props) => {
    if (props.snorlax) {
      return `
          width: 100% !important;
        `;
    }
  }}
  &:hover {
    ${(props) => {
      if (!props.disabled) {
        return css`
          padding-left: 40px;
          padding-right: 40px;
          border-bottom: 7px solid ${colors.darkBlue};
        `;
      }
    }}
  }
  ${(props) => {
    if (props.type) {
      const variant = colors[props.type+"Variant"]
      return css`
        border: 2px solid ${variant};
        background-color: ${colors[props.type]};
        border-bottom: 6px solid ${variant};
        &:hover {
          ${(props) => {
            if (!props.disabled) {
              return css`
                padding-left: 5px;
                padding-right: 5px;
                border-bottom: 7px solid ${variant};
              `;
            }
          }}
        }
        &:active {
          border: 1px solid ${colors[props.type]};
        }
      `;
    }
  }}

  @media(max-width: 700px) {
    padding-left: 3px;
    padding-right: 3px;
    width: 100%;
  }
  ${(props) => {
    if(props.size == "sm"){
      return css`
        padding-left: 1px;
        padding-right: 1px;
      `
    }
  }}

  :disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }

  * {
    color: white !important;
  }
`;

const ButtonContentInner = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;

  i.right {
    margin-right: 15px;
  }

  i.left {
    margin-left: 15px;
  }
`;

export default (props) => {
  return (
    <Button {...props}>
      <ButtonContentInner>
        {props.loading ? <Spinner type={props.type} /> : <React.Fragment />}
        {props.icon && props.iconPosition == "right" ? (
          <Icon type={props.type} className={`${props.icon} right`} />
        ) : (
          <React.Fragment />
        )}
        <Text
          align="center"
          color={props.type || "primary"}
          fontSize={props.size || "1.1em"}
          className="m-0 p-0"
        >
          {props.label}
        </Text>
        {props.icon &&
        (props.iconPosition == "left" || props.iconPosition == undefined) ? (
          <Icon type={props.type} className={`${props.icon} left`} />
        ) : (
          <React.Fragment />
        )}
      </ButtonContentInner>
    </Button>
  );
};



// WEBPACK FOOTER //
// ./src/_components/Button/EasyButton/index.jsx